import React, { useState } from "react";
import {
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    CircularProgress,
    Snackbar,
    Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { fetchWithAuth } from "../../utils/api";

const AdminGeneratePetpage = () => {
    const theme = useTheme();
    const [option, setOption] = useState("");
    const [loading, setLoading] = useState(false);
    const [html, setHtml] = useState("");
    const [copySuccess, setCopySuccess] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const data = await fetchWithAuth(`/admin/generate-petpage-html?type=${option}`);
            if (data.html) {
                let fixedHtml = data.html.replace("Dyeworks White: Prism Light Filter", "Dyeworks White : Prism Light Filter").replace("Dyeworks Blue: Rainbow Petal Shower", "Dyeworks Blue:Rainbow Petal Shower");
                setHtml(fixedHtml);
            }
        } catch (error) {
            setHtml(`Fetch failed: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: { xs: 2, md: 4 } }}>
            {/* Just the header in accent color */}
            <Typography
                variant="h5"
                sx={{ color: theme.palette.accent.main, mb: 2 }}
            >
                Generate Petpage
            </Typography>

            <RadioGroup
                row
                value={option}
                onChange={(e) => setOption(e.target.value)}
                sx={{ mb: 2 }}
            >
                <FormControlLabel value="token" control={<Radio />} label="token" />
                <FormControlLabel
                    value="wearable"
                    control={<Radio />}
                    label="(non)wearables"
                />
            </RadioGroup>

            <Button
                variant="contained"
                disabled={!option || loading}
                onClick={handleSubmit}
                startIcon={loading && <CircularProgress size={16} />}
                sx={{ mb: 3 }}
            >
                Generate
            </Button>
            <Stack spacing={2}>
                <Box
                    component="textarea"
                    value={html}
                    readOnly
                    placeholder="Generated HTML will appear here..."
                    sx={{
                        width: '100%',
                        height: 400, // fixed height ensures scrolling
                        fontFamily: 'monospace',
                        fontSize: '0.95rem',
                        overflowY: 'auto',
                        resize: 'none',
                        padding: 2,
                        border: '1px solid #ccc',
                        borderRadius: 1,
                        backgroundColor: (theme) => theme.palette.background.paper,
                        color: (theme) => theme.palette.text.primary,
                        '&::-webkit-scrollbar': {
                            width: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#ccc',
                            borderRadius: '3px',
                        },
                        scrollbarWidth: 'thin',
                    }}
                />

                <Button
                    variant="outlined"
                    onClick={() => {
                        navigator.clipboard.writeText(html).then(() => {
                            setCopySuccess(true);
                        }).catch((err) => {
                            console.error("Copy failed:", err);
                        });
                    }}
                    disabled={!html}
                >
                    Copy to Clipboard
                </Button>
            </Stack>

            <Snackbar
                open={copySuccess}
                autoHideDuration={3000}
                onClose={() => setCopySuccess(false)}
                message="Copied to clipboard!"
            />
        </Box>
    );
};

export default AdminGeneratePetpage;
